'use es6';

import { handleActions } from 'flux-actions';
import get from 'transmute/get';
import IndexedAsyncData from 'conversations-async-data/indexed-async-data/IndexedAsyncData';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
import { updateEntries } from 'conversations-async-data/indexed-async-data/operators/updateEntries';
import { requestFailed } from 'conversations-async-data/async-data/operators/requestFailed';
import { requestSucceededWithOperator } from 'conversations-async-data/async-data/operators/requestSucceededWithOperator';
import { updateEntry } from 'conversations-async-data/indexed-async-data/operators/updateEntry';
import ResolvedAttachmentRecord from 'conversations-internal-schema/resolved-attachment/records/ResolvedAttachmentRecord';
import { RESOLVE_ATTACHMENTS_FAILED, RESOLVE_ATTACHMENTS_SUCCEEDED } from '../constants/resolvedAttachmentsActionTypes';
import { THREAD_HISTORY_FILES_RECEIVED } from '../../thread-histories/constants/ActionTypes';
import { ATTACHMENT_UPLOAD_COMPLETE } from '../../file-uploads/constants/fileUploadsActionTypes';
const initialState = IndexedAsyncData({
  notSetValue: AsyncData({
    data: null
  })
});

// this reducer is the main store for attachments inside a thread view
// fileUploads.js is the store that holds uploads in the file component
const reducer = {
  [RESOLVE_ATTACHMENTS_FAILED](state, action) {
    const {
      fileIds
    } = action.payload;
    return updateEntries(fileIds, (_fileId, asyncData) => requestFailed(asyncData), state);
  },
  [RESOLVE_ATTACHMENTS_SUCCEEDED](state, action) {
    const {
      fileIds,
      resolvedAttachments
    } = action.payload;
    return updateEntries(fileIds, (fileId, asyncData) => {
      return requestSucceededWithOperator(() => {
        return get(fileId, resolvedAttachments);
      }, asyncData);
    }, state);
  },
  [ATTACHMENT_UPLOAD_COMPLETE](state, action) {
    const {
      fileId,
      uploadedFile
    } = action.payload;
    const attachmentRecord = new ResolvedAttachmentRecord({
      fileMetadata: uploadedFile,
      fileId
    });
    return updateEntry(fileId, entry => requestSucceededWithOperator(() => attachmentRecord, entry), state);
  },
  [THREAD_HISTORY_FILES_RECEIVED](state, action) {
    const {
      files: resolvedAttachments
    } = action.payload;
    const fileIds = resolvedAttachments.keySeq().toList();
    return updateEntries(fileIds, (fileId, asyncData) => {
      return requestSucceededWithOperator(() => {
        return get(fileId, resolvedAttachments);
      }, asyncData);
    }, state);
  }
};
export default handleActions(reducer, initialState);